/* eslint-disable */
/**
 * AUTOGENERATED — DO NOT EDIT.
 *
 * Generated from:
 *   backend/api/sls/lambda-python3.9/layers/stepflow_core/python/stepflow_core/pricing/v1.py
 *
 * Regenerate via ``npm run generate:pricing`` (also wired as a prebuild
 * hook on ``apps/web``). Edit the Python file to change rates; this
 * file rewrites on the next build.
 */

export interface ModelRow {
  usd_input: number;
  usd_output: number;
  usd_input_batch: number | null;
  usd_output_batch: number | null;
  pts_input: number;
  pts_output: number;
  label: string;
}

export const MODEL_ROWS: Record<string, ModelRow> = {
  opus: {
      "usd_input": 5,
      "usd_output": 25,
      "usd_input_batch": 2.5,
      "usd_output_batch": 12.5,
      "label": "Reason",
      "pts_input": 0.005,
      "pts_output": 0.025
  },
  sonnet: {
      "usd_input": 3,
      "usd_output": 15,
      "usd_input_batch": 1.5,
      "usd_output_batch": 7.5,
      "label": "Think",
      "pts_input": 0.003,
      "pts_output": 0.015
  },
  haiku: {
      "usd_input": 1.1,
      "usd_output": 5.5,
      "usd_input_batch": 0.55,
      "usd_output_batch": 2.75,
      "label": "Fast",
      "pts_input": 0.0011,
      "pts_output": 0.0055
  },
  haiku3: {
      "usd_input": 0.275,
      "usd_output": 1.375,
      "usd_input_batch": 0.1375,
      "usd_output_batch": 0.6875,
      "label": "Summarization",
      "pts_input": 0.000275,
      "pts_output": 0.001375
  },
  titan: {
      "usd_input": 0.1,
      "usd_output": 0,
      "usd_input_batch": 0.05,
      "usd_output_batch": 0,
      "label": "Vector embed",
      "pts_input": 0.0001,
      "pts_output": 0
  },
};

/** Resolve any known model id (regional / inference-profile alias /
 *  legacy) to the family key used by MODEL_ROWS. */
export const MODEL_ID_TO_FAMILY: Record<string, keyof typeof MODEL_ROWS> = {
  "anthropic.claude-opus-4-6-v1": "opus",
  "global.anthropic.claude-opus-4-6-v1": "opus",
  "us.anthropic.claude-opus-4-6-v1": "opus",
  "anthropic.claude-sonnet-4-6": "sonnet",
  "global.anthropic.claude-sonnet-4-6": "sonnet",
  "us.anthropic.claude-sonnet-4-6": "sonnet",
  "anthropic.claude-opus-4-7": "opus",
  "global.anthropic.claude-opus-4-7": "opus",
  "anthropic.claude-opus-4-8": "opus",
  "global.anthropic.claude-opus-4-8": "opus",
  "anthropic.claude-opus-5": "opus",
  "global.anthropic.claude-opus-5": "opus",
  "anthropic.claude-sonnet-5": "sonnet",
  "global.anthropic.claude-sonnet-5": "sonnet",
  "anthropic.claude-opus-4-5-20251001-v1:0": "opus",
  "global.anthropic.claude-opus-4-5-20251001-v1:0": "opus",
  "anthropic.claude-opus-4-5-20251101-v1:0": "opus",
  "global.anthropic.claude-opus-4-5-20251101-v1:0": "opus",
  "anthropic.claude-sonnet-4-5-20250929-v1:0": "sonnet",
  "global.anthropic.claude-sonnet-4-5-20250929-v1:0": "sonnet",
  "us.anthropic.claude-sonnet-4-5-20250929-v1:0": "sonnet",
  "eu.anthropic.claude-sonnet-4-5-20250929-v1:0": "sonnet",
  "anthropic.claude-haiku-4-5-20251001-v1:0": "haiku",
  "global.anthropic.claude-haiku-4-5-20251001-v1:0": "haiku",
  "us.anthropic.claude-haiku-4-5-20251001-v1:0": "haiku",
  "eu.anthropic.claude-haiku-4-5-20251001-v1:0": "haiku",
  "anthropic.claude-3-haiku-20240307-v1:0": "haiku3",
  "amazon.titan-embed-text-v1": "titan",
  "amazon.titan-embed-text-v2:0": "titan",
};

export const CACHE_READ_MULTIPLIER = 0.1;
export const CACHE_CREATION_MULTIPLIER = 1.25;

/** Family-level dispatch (substring match on model id) — kept for the
 *  MODEL_PRICING.haiku|sonnet|opus shape that legacy callers expect. */
export const MODEL_PRICING = {
  haiku: { input: MODEL_ROWS.haiku.usd_input, output: MODEL_ROWS.haiku.usd_output },
  sonnet: { input: MODEL_ROWS.sonnet.usd_input, output: MODEL_ROWS.sonnet.usd_output },
  opus: { input: MODEL_ROWS.opus.usd_input, output: MODEL_ROWS.opus.usd_output },
} as const;

/** Plan catalog mirror. Source of truth is
 *  ``stepflow_core/pricing/plans.py``. The PLAN_CATALOG (Python) →
 *  GENERATED_PLAN_CATALOG (TS) link is via build-time regex parse;
 *  edit the Python file, regenerate.
 *
 *  ``points_per_period === -1`` is the UNLIMITED_BUDGET sentinel
 *  (PayG wallet model). All other finite-budget plans carry the
 *  catalog-declared int. */
export interface PlanCatalogEntry {
  key: string;
  name: string;
  description: string;
  price_cents: number | null;
  interval: string | null;
  points_per_period: number;
  lookup_key: string | null;
  metered?: boolean;
  contact_only?: boolean;
  badge?: string;
  highlight?: boolean;
  sort_order: number;
}

export const GENERATED_PLAN_CATALOG: PlanCatalogEntry[] = [
  {
    "key": "payg",
    "name": "Pay as you go",
    "description": "Metered usage — pay for what you run, no monthly minimum.",
    "price_cents": 100,
    "interval": "month",
    "points_per_period": -1,
    "lookup_key": "stepflow_payg_v1",
    "metered": true,
    "sort_order": 10
  },
  {
    "key": "starter",
    "name": "Starter",
    "description": "Flat monthly — solo devs and small experiments.",
    "price_cents": 2000,
    "interval": "month",
    "points_per_period": 25000,
    "lookup_key": "stepflow_starter_v1",
    "sort_order": 20
  },
  {
    "key": "pro",
    "name": "Pro",
    "description": "Production workloads, small teams.",
    "price_cents": 6000,
    "interval": "month",
    "points_per_period": 90000,
    "lookup_key": "stepflow_pro_v1",
    "badge": "Popular",
    "highlight": true,
    "sort_order": 30
  },
  {
    "key": "ultra",
    "name": "Ultra",
    "description": "Heavy-usage teams that need predictable monthly cost.",
    "price_cents": 10000,
    "interval": "month",
    "points_per_period": 180000,
    "lookup_key": "stepflow_ultra_v1",
    "sort_order": 40
  },
  {
    "key": "enterprise",
    "name": "Enterprise",
    "description": "SSO, SLAs, dedicated support — contracted directly.",
    "price_cents": null,
    "interval": null,
    "points_per_period": 0,
    "lookup_key": null,
    "contact_only": true,
    "sort_order": 50
  },
];

export const UNLIMITED_BUDGET = -1;

/** Mirror of stepflow_core.pricing.plans.next_finite_tier_after.
 *  Used by the in-context upgrade card to suggest the next paid
 *  finite-budget plan above the current one. PayG / unknown →
 *  Starter; Starter → Pro; Pro → Ultra; Ultra / Enterprise → null. */
export function nextFiniteTierAfter(planKey: string | null | undefined): PlanCatalogEntry | null {
  const finite = GENERATED_PLAN_CATALOG
    .filter((p) => !p.contact_only && p.points_per_period !== UNLIMITED_BUDGET)
    .sort((a, b) => a.sort_order - b.sort_order);
  if (finite.length === 0) return null;
  const pk = (planKey || '').trim().toLowerCase();
  const current = GENERATED_PLAN_CATALOG.find((p) => p.key === pk);
  if (!current) return finite[0];
  if (current.contact_only) return null;
  if (current.points_per_period === UNLIMITED_BUDGET) return finite[0];
  return finite.find((p) => p.sort_order > current.sort_order) ?? null;
}
